"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LeftSideMenu',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      menuItems: [{
        key: 'home',
        label: '小程序首页'
      }, {
        key: 'welfare',
        label: '福利社'
      }, {
        key: 'pointsMall',
        label: '积分商城'
      }, {
        key: 'recharge',
        label: '充值页'
      }, {
        key: 'menu',
        label: '菜单页'
      }, {
        key: 'cart',
        label: '购物车'
      },
      // { key: 'checkout', label: '结算页' },
      {
        key: 'paymentDone',
        label: '支付完成页'
      }, {
        key: 'orderDetail',
        label: '订单详情页'
      }, {
        key: 'communityHome',
        label: '社区首页'
      },
      // { key: 'communityDay', label: '社区会员日' },
      {
        key: 'communityCenter',
        label: '社区个人中心'
      }, {
        key: 'tablePredetermine',
        label: 'table预定页'
      }, {
        key: 'groupOrder',
        label: '团餐配置'
      }, {
        key: 'orderPay',
        label: '订单支付页'
      }]
    };
  },
  computed: {
    currentValue: function currentValue() {
      return this.value;
    }
  },
  methods: {
    onMenuSelect: function onMenuSelect(key) {
      var selectedItem = this.menuItems.find(function (item) {
        return item.key === key;
      });
      this.$emit('input', key);
      this.$emit('select', selectedItem);
    }
  }
};